import React from "react";
import Select from 'react-select';

const Form = ({cuenta, errors}) => {
    return (
        <div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Nombre:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <input
                        type='text'
                        className='text-input form-control'
                        id='nombre'
                        name='nombre'
                        readOnly={cuenta.defecto}
                        defaultValue={cuenta.nombre}
                    />
                    {errors.nombre && (
                        <small className='help-blockParams form-Text'>
                            {errors.nombre[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Número:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <input
                        type='text'
                        className='text-input form-control'
                        id='numero'
                        name='numero'
                        defaultValue={cuenta.numero}
                    />
                    {errors.numero && (
                        <small className='help-blockParams form-Text'>
                            {errors.numero[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Grupo:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <Select
                        name="grupo"
                        key="grupo"
                        defaultValue={cuenta.grupo && {label: cuenta.grupo, value: cuenta.grupo}}
                        menuPosition='fixed'
                        menuPlacement='auto'
                        options={[
                            {label: "Real", value: "real"},
                            {label: "Nominal", value: "nominal"},
                            {label: "Mixta", value: "mixta"},
                            {label: "De Orden", value: "orden"}
                        ]}
                    />
                    {errors.grupo && (
                        <small className='help-blockParams form-Text'>
                            {errors.grupo[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className="row form-group">
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Tipo:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <Select
                        name="tipo"
                        key="tipo"
                        defaultValue={cuenta.tipo && {label: cuenta.tipo, value: cuenta.tipo}}
                        menuPosition='fixed'
                        menuPlacement='auto'
                        options={[
                            {label: "Activo", value: "activo"},
                            {label: "Capital", value: "capital"},
                            {label: "Costos", value: "costos"},
                            {label: "Gastos", value: "gastos"},
                            {label: "Ingresos", value: "ingresos"},
                            {label: "Pasivos", value: "pasivos"},
                        ]}
                    />
                    {errors.tipo && (
                        <small className='help-blockParams form-Text'>
                            {errors.tipo[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className="row form-group">
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Categoría:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <Select
                        name="categoria"
                        key="categoria"
                        defaultValue={cuenta.categoria && {label: cuenta.categoria, value: cuenta.categoria}}
                        menuPosition='fixed'
                        menuPlacement='auto'
                        options={[
                            {label: "Mayor", value: "mayor"},
                            {label: "Subcuenta", value: "subcuenta"},
                            {label: "Auxiliar", value: "auxiliar"},
                        ]}
                    />
                    {errors.categoria && (
                        <small className='help-blockParams form-Text'>
                            {errors.categoria[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className="row form-group">
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Estado:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <Select
                        name="estado"
                        key="estado"
                        defaultValue={cuenta.estado && {label: cuenta.estado, value: cuenta.estado}}
                        menuPosition='fixed'
                        menuPlacement='auto'
                        options={[
                            {label: "Activa", value: "activa"},
                            {label: "Inactiva", value: "inactiva"},
                        ]}
                    />
                    {errors.estado && (
                        <small className='help-blockParams form-Text'>
                            {errors.estado[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Naturaleza:
                    </label>
                </div>
                <div className='col col-md-7'>
                    {cuenta.defecto ? (
                        <input
                            type='text'
                            readOnly
                            className='text-input form-control'
                            value={cuenta.naturaleza}
                        />
                    ) : (
                        <Select
                            name="naturaleza"
                            key="naturaleza"
                            menuPosition='fixed'
                            menuPlacement='auto'
                            defaultValue={cuenta.naturaleza && {label: cuenta.naturaleza, value: cuenta.naturaleza}}
                            options={[
                                {label: "Crédito", value: "credito"},
                                {label: "Débito", value: "debito"}
                            ]}
                        />
                    )}
                    {errors.naturaleza && (
                        <small className='help-blockParams form-Text'>
                            {errors.naturaleza[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Clasificación:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <input
                        type='text'
                        className='text-input form-control'
                        id='clasificacion'
                        name='clasificacion'
                        defaultValue={cuenta.clasificacion}
                    />
                    {errors.clasificacion && (
                        <small className='help-blockParams form-Text'>
                            {errors.clasificacion[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Descripción:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <textarea name="descripcion" defaultValue={cuenta.descripcion} className="form-control"></textarea>
                    {errors.descripcion && (
                        <small className='help-blockParams form-Text'>
                            {errors.descripcion[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Form;
